import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client'
import api from '../../services/api_adiantamento';
import styles from "./styles.module.css";

export default function Dashboards() {

    const [dashboard, setDashboard] = useState({});
    const [canView, setCanView] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [verification, setVerification] = useState(false);
    const [painelView, setPainelView] = useState(false);

    const { id } = useParams();

    useEffect(() => {
        api.get(`/dashboards/canview?dashboard_id=${id}`).then(function (response) {
            if (response.data) {
                if (response.data.disabled) {
                    setDisabled(true);
                    setCanView(false);
                    return;
                }
                setCanView(true);
            }
        }).catch(function (error) {
            setCanView(false);
            // handle error
            console.log(error);
        }).then(function () {
            setVerification(true);

        });
    }, []);

    useEffect(() => {
        if (canView) {
            api.get(`/dashboards/dashboard_id/${id}`).then(function (response) {
                if (response.data) {
                    if(response.data.html && !response.data.public_url) {
                        setPainelView(true);
                    }
                    setDashboard(response.data);
                }
            }).catch(function (error) {
                // handle error
                console.log(error);
            }).then(function () {
                // always executed
            });
        }
    }, [id, canView]);

    function renderButtonChangeDashboard() {
        if(dashboard.html && dashboard.public_url) {
            return (
                <div className={styles.botao}>
                    <input type="button" value={painelView ? 'VISÃO PADRÃO DO DASHBOARD' : 'VISÃO DE PAINÉIS AUTOMÁTICOS'}
                        onClick={() => setPainelView(!painelView)} className="btn btn-primary"
                    />
                </div>
            )
        }
    }

    function renderBi() {

        if (canView) {
            return (
                // <PowerBIEmbed
                //     embedConfig={{
                //         type: 'report',   // Supported types: report, dashboard, tile, visual and qna
                //         id: dashboard.report_id,
                //         embedUrl: dashboard.embed_url,
                //         accessToken: token,
                //         // filters: [
                //         //     {
                //         //         $schema: "http://powerbi.com/product/schema#basic",
                //         //         target: {
                //         //             table: "d_Empresa",
                //         //             column: "id_empresa"
                //         //         },
                //         //         // @ts-ignore 
                //         //         operator: "In",
                //         //         values: [2],
                //         //         filterType: models.FilterType.BasicFilter,
                //         //         requireSingleSelection: true
                //         //     },
                //         //     {
                //         //         $schema: "http://powerbi.com/product/schema#basic",
                //         //         target: {
                //         //             table: "d_Calendario",
                //         //             column: "MesNum"
                //         //         },
                //         //         // @ts-ignore 
                //         //         operator: "In",
                //         //         values: [8],
                //         //         filterType: models.FilterType.BasicFilter,
                //         //         requireSingleSelection: true
                //         //     }
                //         // ],
                //         tokenType: models.TokenType.Embed,
                //         settings: {
                //             panes: {
                //                 filters: {
                //                     expanded: false,
                //                     visible: false
                //                 }
                //             },
                //             // background: models.BackgroundType.Transparent,
                //         }
                //     }}

                //     eventHandlers={
                //         new Map([
                //             ['loaded', function () { console.log('Report loaded'); }],
                //             ['rendered', function () { console.log('Report rendered'); }],
                //             ['error', function (event) { console.log(event.detail); }]
                //         ])
                //     }
                //     cssClassName={styles.a}

                //     getEmbeddedComponent={(embeddedReport) => {
                //         window.report = embeddedReport;
                //     }}
                // />
                <>
                    <iframe src={painelView ? dashboard.htmlUrl : dashboard.public_url} title='Dashboard' style={{width: '100%', height: 'calc(100vh - 16px)'}} />
                    {renderButtonChangeDashboard()}
                </>
            )
        } else {
            if (disabled) {
                return (
                    <div style={{ marginTop: '50px'}}>
                        <h1>ESTE RELATÓRIO NÃO ESTÁ MAIS DISPONÍVEL AQUI!</h1>
                        <br/>
                        <h4>Acesse este dashboard através da <a href="https://indicadores-controladoria.grupojapungu.com" target='_blank' rel='noreferrer'>Plataforma Controladoria | Indicadores</a>.</h4>
                        <h4>Caso ainda não tenha um usuário ou seu acesso não esteja liberado, entre em contato com a equipe da Controladoria.</h4>
                    </div>
                )
            }
            if (verification) {
                return (
                    <h1>LAMENTAMOS, MAS SEU USUÁRIO NÃO TEM PERMISSÃO PARA VISUALIZAR ESTE RELATÓRIO!</h1>
                )
            }
        }
    }

    return (
        <>
            {renderBi()}
        </>
    )
}